module.exports = __webpack_public_path__ + "img/spain-infectious-diseases-female.3927d804.png";